import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import ArticleDetail from '../views/ArticleDetail.vue'
import Login from '../views/Login.vue'
import Register from '../views/Register.vue'
import Services from '../views/Services.vue'
import NoticeList from '../views/NoticeList.vue'
import MemberList from '../views/MemberList.vue'
import MemberDetail from '../views/MemberDetail.vue'
import ProductList from '../views/ProductList.vue'
import ProductDetail from '../views/ProductDetail.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/article/:id',
    name: 'ArticleDetail',
    component: ArticleDetail,
    props: true
  },
  {
    path: '/member-detail/:id',
    name: 'MemberDetail',
    component: MemberDetail,
    props: true
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/register',
    name: 'Register',
    component: Register
  },
  {
    path: '/services',
    name: 'Services',
    component: Services
  },
  {
    path: '/notices',
    name: 'NoticeList',
    component: NoticeList
  },
  {
    path: '/members',
    name: 'MemberList',
    component: MemberList
  },
  {
    path: '/product',
    name: 'ProductList',
    component: ProductList
  },
  {
    path: '/productDetail/:id',
    name: 'ProductDetail',
    component: ProductDetail
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

export default router
